import React, { useState } from "react";
import Password from "../../Components/UI/Inputs/Password";
import Button from "../../Components/UI/Buttons/Button";
import { useTranslation } from "react-i18next";
import useApi from "../../Hooks/useApi";
import { useParams } from "react-router-dom";
import showToast from "../../Helpers/toast";


const NewPasswordSetter = () => {
  const { t } = useTranslation();
  const { request } = useApi({ isPublic: true });

  const initialFormState = {
    password: "",
    confirmPassword: "",
  };
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState(initialFormState);
  const [error, setError] = useState("");

  const handleInputChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const token = useParams()?.token;

  const handleNewPasswordSubmit = () => {
    const { password, confirmPassword } = formData;
    setError("");
    try {
      if (password !== confirmPassword) {
        setError("Passwords do not match");
        return;
      }
      request("POST", `/v1/auth/reset-password/${token}`, {
        data: {
          password: password,
          retypePassword: confirmPassword,
        },
      });
      showToast({ message:"Password reset successfully." });
    } catch (error) {
      
    } finally {
      setFormData(initialFormState);
    }
  };

  return (
    <div className=" px-2  w-full h-full  py-20">
      <div className="border-2 border-[#E0F5FD] rounded lg:w-[500px] shadow-md mx-auto  ">
        <div className="mb-8 text-center">
          <h2 className="text-xl text-[#7DDBFF] mt-5">
            {t("login.password-setter")}
          </h2>
          <h2 className="text-2xl font-bold text-[#7DDBFF]">
            {t("login.title")}
          </h2>
        </div>
        <div className="flex flex-col !px-[8%]  h-full mb-[8%]">
          <p className="text-[#6F6F6F] text-sm my-2">
            Please enter a new password.
          </p>
          <Password
            required
            placeholder={"New password"}
            name="password"
            showPassword={showPassword}
            onValueChange={handleInputChange}
            togglePassword={() => setShowPassword(!showPassword)}
            value={formData.password}
          />
          <Password
            required
            placeholder={"Re-type new password"}
            name="confirmPassword"
            showPassword={showPassword}
            onValueChange={handleInputChange}
            togglePassword={() => setShowPassword(!showPassword)}
            value={formData.confirmPassword}
          />
          <div className="text-red-500 text-sm mt-1  px-2">{error}</div>
          <Button
            type="full"
            label={"Submit"}
            textColor="white"
            backgroundColor="#7DDBFF"
            handler={handleNewPasswordSubmit}
          />
        </div>
      </div>
    </div>
  );
};

export default NewPasswordSetter;
